enum QuantityStepperType {
  OUTLINED = 'outlined',
  FILLED = 'filled',
}

enum QuantityStepperSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}
enum QuantityStepperStatus {
  VALID = 'valid',
  INVALID = 'invalid',
  DEFAULT = 'default',
}
export { QuantityStepperType, QuantityStepperSize, QuantityStepperStatus };
